import {
  getDocFlowMappingTypeOptions,
  isDocFlowSplittingType,
} from '../DocFlow.utils.mapping'
import { isDocFlowActiveWidgetType } from '../DocFlow.utils.widgets'
import {
  DocFlowMappingTypeWidget,
  DocFlowMappingWidgetMapping,
  DocFlowMappingWidgetResult,
  DocFlowMappingWidgetSplitting,
} from '../DocFlowWidgets'

import { MappingWidgetType } from './DocFlowMappingWidgets.constants'

export function getDocFlowMappingActiveFileType(file, t) {
  return getDocFlowMappingTypeOptions(t).find(item => item.value === file?.type)
}

export function getDocFlowWidgets(t) {
  return [
    {
      name: MappingWidgetType.Type,
      title: t('DocumentStapling.MappingPhaseTypeWidgetTitleKey'),
    },
    {
      name: MappingWidgetType.Splitting,
      title: t('DocumentStapling.MappingPhaseSplittingWidgetTitleKey'),
    },
    {
      name: MappingWidgetType.Mapping,
      title: t('DocumentStapling.MappingPhaseMappingWidgetTitleKey'),
    },
    {
      name: MappingWidgetType.Result,
      title: t('DocumentStapling.MappingPhaseResultWidgetTitleKey'),
    },
  ]
}

export function renderWidget({ activeType, name, ...restProps }) {
  if (isDocFlowActiveWidgetType(name)) {
    return (
      <DocFlowMappingTypeWidget
        {...restProps}
        activeType={activeType}
        name={name}
      />
    )
  }

  if (isDocFlowSplittingType(activeType?.value)) {
    switch (name) {
      case MappingWidgetType.Splitting:
        return <DocFlowMappingWidgetSplitting {...restProps} name={name} />

      case MappingWidgetType.Mapping:
        return <DocFlowMappingWidgetMapping {...restProps} name={name} />

      case MappingWidgetType.Result:
        return <DocFlowMappingWidgetResult {...restProps} name={name} />

      default:
        return null
    }
  }
}
